import { tCustomer, tCustomerFeedback } from "../data/Customers";
import './CustomerFeedbackPopup.css';

interface CustomerFeedbackPopupProps {
  customers: tCustomer[];
  customerFeedback: tCustomerFeedback[];
  closeFeedbackCallback: () => void;
}

export default function CustomerFeedbackPopup(props: CustomerFeedbackPopupProps) {
  return (
    <div className="popup-overlay">
      <div className={`customer-feedback-popup-modal`}>
        <h3>🗨️ Customer Feedback</h3>
        <table className="feedback-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Status</th>
              <th>Feedback</th>
              <th>Venues</th>
              <th>Revenue</th>
            </tr>
          </thead>
          <tbody>
            {props.customerFeedback.map((feedback, index) => {
              const customer = props.customers.find(c => c.id === feedback.customerId);
              return (
                <tr key={index}>
                  <td>{customer?.icon} {customer?.name}</td>
                  <td>
                    <span className={`status-tag ${customer?.isCustomer ? 'customer' : 'prospect'}`}>
                      {customer?.isCustomer ? 'Customer' : 'Prospect'}
                    </span>
                  </td>
                  <td>{feedback.feedback}</td>
                  <td>{customer?.numberOfSites} / {customer?.maxSites}</td>
                  <td>{customer?.paymentPerSprint}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <button className="close-button" onClick={props.closeFeedbackCallback}>Close</button>
      </div>
    </div>
  );
}
